import { Controller, Post, Body, Req, All } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { LoanCategoryDTO } from './dto/loan-categories.dto';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { AllLoanCategoriesResponse, LoanCategoriesResponse } from '@gtpl/shared-models/hrms';
import { LoanCategoryRequest } from './dto/loan-categories.request';
import { LoanCategoriesService } from './loan-categories.service';

@ApiTags('loan-categories')
@Controller('loan-categories')

export class LoanCategoriesController {
    constructor(
        private service: LoanCategoriesService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ){}

    @Post('/createLoanCategory')
    async createLoanCategory(@Body() DTO: LoanCategoryDTO, isUpdate: boolean = false): Promise<LoanCategoriesResponse>{
        try{
            return await this.service.createLoanCategory(DTO, false);
        }catch(error){
            return this.applicationExceptionHandler.returnException(LoanCategoriesResponse, error);
        }
    }

    @Post('/updateLoanCategory')
    async updateLoanCategory(@Body() DTO: LoanCategoryDTO, isUpdate: boolean = false): Promise<LoanCategoriesResponse>{
        try{
            return await this.service.createLoanCategory(DTO, true);
        }catch(error){
            return this.applicationExceptionHandler.returnException(LoanCategoriesResponse, error);
        }
    }

    @Post('/getAllLoanCategories')
    async getAllLoanCategories(): Promise<AllLoanCategoriesResponse>{
        try{
            return await this.service.getAllLoanCategories();
        }catch(error){
            return this.applicationExceptionHandler.returnException(AllLoanCategoriesResponse, error);
        }
    }

    @Post('/getAllActiveLoanCategories')
    async getAllActiveLoanCategories(): Promise<AllLoanCategoriesResponse>{
        try{
            return await this.service.getAllActiveLoanCategories();
        }catch(error){
            return this.applicationExceptionHandler.returnException(AllLoanCategoriesResponse, error);
        }
    }

    @Post('/activateOrDeactivate')
    async activateOrDeactivate(@Body() catReq: LoanCategoryRequest): Promise<LoanCategoriesResponse>{
        try{
            return await this.service.activateOrDeactivateLoanCategory(catReq);
        }catch(error){
            return this.applicationExceptionHandler.returnException(LoanCategoriesResponse, error);
        }
    }
}
